import React from 'react';
import { MESSAGE_STYLES } from '../../constants/styles';
import Toast from './Toast';

export const SuccessMessage = ({ message, onClose }) => {
    if (!message) return null;

    return (
        <Toast
            message={message}
            type="success"
            duration={6000}
            onClose={onClose}
        />
    );
};

export const ErrorMessage = ({ message, onClose }) => {
    if (!message) return null;

    return (
        <Toast
            message={message}
            type="error"
            duration={5000}
            onClose={onClose}
        />
    );
};

export const WarningMessage = ({ children }) => (
    <div style={MESSAGE_STYLES.warning}>
        {children}
    </div>
);

export const LockMessage = ({ isLocked }) => {
    if (!isLocked) return null;

    return (
        <div style={{
            margin: '10px',
            padding: '10px',
            backgroundColor: 'rgb(255, 213, 205)',
            border: '1px solid rgb(255, 185, 167)',
            borderRadius: '8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            color: 'rgba(157, 35, 45, 0.88)',
        }}><div>
                <h4 style={{
                    margin: '0 0 5px 0',
                    color: 'rgb(157, 35, 45)',
                    fontSize: '14px'
                }}>
                    ❗️Deadline Passed
                </h4>
                <p style={{
                    margin: 0,
                    color: 'rgb(157, 35, 45)',
                    fontSize: '12px'
                }}>
                    Changes window is closed for this delivery date. You can still view your meals, but please contact us if you need to make any changes.</p>
            </div>
        </div>
    );
};

export const ValidationWarning = ({ message }) => (
    <div style={{
        backgroundColor: '#ffeaa7',
        border: '1px solid #fdcb6e',
        borderRadius: '4px',
        padding: '8px 12px',
        marginTop: '8px',
        fontSize: '12px',
        color: '#e17055',
        fontWeight: '500',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        marginBottom: '10px'
    }}>
        <span>⚠️</span>
        {message}
    </div>
);